/**
 * The code a website needs to show the calendar in a frame (D36), in three forms (D41), for the
 * backoffice and for a customer's own page in the portal (E6b).
 *
 * THE SHORTCODE is for the magazines' WordPress, where the plugin of `integrations/wordpress`
 * turns it into the frame and loads the script of the calendar's host on that page alone. An
 * editor who only has the rich text field can place it.
 *
 * THE FRAME AND THE SCRIPT LINE are for any website that keeps a script. The frame goes into
 * the page; the line loads `einbettung.js` from the calendar's host (participant
 * `pages/einbettung.js.ts`), which sizes every frame of that host on the page and lays a door
 * over the whole page where the action shows its doors as a dialog (D37). The script is served,
 * not copied, so a change to it reaches every website without anybody touching it again.
 *
 * THE BARE FRAME needs nothing a rich text field removes: on physiotherapeuten.de the editor
 * kept `width`, `height` and `frameborder` and dropped `id`, `style` and any script
 * (15.10.2026). Without the script the frame keeps its first height and the doors open as a
 * page inside it, which still works.
 *
 * No `sandbox` on the frame: it would send `Origin: null` with the answer form, and the
 * calendar refuses that as a request from another site.
 */
/** The frame's height until the script sets it: about the calendar of 24 doors in an article. */
const FIRST_HEIGHT = 1000;
const MODE_QUERY = {
    rahmen: 'einbettung',
    tab: 'einbettung=tab',
    gast: 'einbettung=gast',
};
const escapeAttribute = (value) => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
/** The frame for the page. */
export function embedFrame({ calendarUrl, title, mode = 'rahmen', }) {
    const url = new URL(calendarUrl);
    const src = `${url.origin}${url.pathname}${url.search === '' ? '?' : `${url.search}&`}${MODE_QUERY[mode]}&kanal=website`;
    return `<iframe src="${escapeAttribute(src)}" title="${escapeAttribute(title)}" width="100%" height="${String(FIRST_HEIGHT)}" frameborder="0" loading="lazy"></iframe>`;
}
/** The line that loads the script of the calendar's host, once per page. */
export function embedScript(calendarUrl) {
    return `<script src="${new URL(calendarUrl).origin}/einbettung.js" async></script>`;
}
/**
 * The shortcode for the magazines' WordPress. Quotes and square brackets would end the
 * shortcode early, so the title loses them; the address is a URL and has none.
 */
export function embedShortcode({ calendarUrl, title, }) {
    return `[countdown src="${calendarUrl}" titel="${title.replace(/["[\]]/g, '')}"]`;
}
/**
 * The websites of a text field, one per line, as the API takes them: without a closing slash
 * and in lower case, as a browser sends an origin. Whatever else is wrong the API refuses.
 */
export function originsOf(raw) {
    return raw
        .split(/\r?\n/)
        .map((line) => line.trim().replace(/\/+$/, '').toLowerCase())
        .filter((line) => line !== '');
}
//# sourceMappingURL=embed.js.map